<template>
  <div class="container">
    <van-cell
      class="header"
      :title="`${month}月`"
      title-class="title"
      :value="`活动账单：${amountInYuan}元`"
      value-class="value"
      center
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <div
          v-for="(item,index) in list"
          :key="index"
          class="cell-card"
          @click="gotoActivityDetail(item)"
        >
          <div class="cell-head">
            <div class="head-left">
              {{ item.agreementName }}
            </div>
            <div class="head-right">
              查看账单<van-icon name="arrow" />
            </div>
          </div>
          <div class="cell-row">
            <div>编号：{{ item.agreementId }}</div>
          </div>
          <div class="cell-row">
            <div></div>
            <div>
              账单金额：<span class="number">{{ item.agreementBillAmount }}元</span>
            </div>
          </div>
        </div>
      </template>
    </LongList>
  </div>
</template>
<script>
import { formatYearMonth, getMonth, formatAmount } from '@/util/filter';
import LongList from '@/components/LongList';
import Api from '@/api/bill';

export default {
  name: 'AgentActivityBillList',
  components: {
    LongList,
  },
  filters: {
    formatYearMonth,
    getMonth,
  },
  data() {
    const { billType, billMonth, amount } = this.$route.query;
    return {
      billType,
      billMonth,
      amount,
    };
  },
  computed: {
    month() {
      return getMonth(this.billMonth);
    },
    amountInYuan() {
      return formatAmount(this.amount);
    },
  },
  methods: {
    getData(pageNum, pageSize) {
      const { billType, billMonth } = this;
      const params = {
        billType: Number(billType),
        billMonth,
        pageNum,
        pageSize,
      };
      return Api.getAgentActivityBill(params);
    },
    gotoActivityDetail(item) {
      const { billType, billMonth } = this;
      const { agreementId: id, agreementName: name, agreementBillAmount: amount } = item;
      this.$router.push({
        name: 'AgentActivityBillDetail',
        query: {
          billType,
          billMonth,
          id,
          name,
          amount,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 16px 16px 0;
}

.header {
  background: none;

  .title {
    text-align: left;
    font-weight: bold;
    font-size: 36px;
    color: black;
  }
  .value {
    font-size: 28px;
    color:black;
  }
}

.cell-card {
  .cell-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 30px;

    .head-left {
      text-align: left;
    }

    .head-right {
      font-weight: normal;
      font-size: 26px;
      flex-basis: 180px;
      text-align: right;
    }
  }

  .cell-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    &:last-child {
      padding-bottom: 0;
    }

  }
}
</style>
